//TODO make these more dynamic
export const BORDER_DASH_GRADIENT = `"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3cdefs%3e%3clinearGradient id='gradientBorder' x1='0%25' y1='0%25' x2='100%25' y2='0%25'%3e%3cstop offset='0%25' style='stop-color:%23FFFD62;stop-opacity:.4'/%3e%3cstop offset='50%25' style='stop-color:%23FF6AE6;stop-opacity:.4'/%3e%3c/linearGradient%3e%3c/defs%3e%3crect width='100%25' height='100%25' fill='none' stroke='url(%23gradientBorder)' stroke-width='2' stroke-dasharray='6' stroke-dashoffset='2' stroke-linecap='square' rx='8' ry='8'/%3e%3c/svg%3e"`;
export const BORDER_DASH_GRAY_400 = `"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23908CA0' stroke-width='1' stroke-dasharray='4' stroke-dashoffset='2' stroke-linecap='square' rx='16' ry='16'/%3e%3c/svg%3e"
`;

export const generateBorderDashSvg = (
  strokeColor: string,
  borderRadius: number = 16,
  dashLength: number = 4,
  gapLength: number = 4
): string => {
  let color = strokeColor;

  // handle CSS variable format - var(--gray-500) or --gray-500
  if (strokeColor.startsWith('var(')) {
    const variableName = strokeColor.match(/var\((.*?)\)/)?.[1];
    if (variableName) {
      color = getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
    }
  } else if (strokeColor.startsWith('--')) {
    color = getComputedStyle(document.documentElement).getPropertyValue(strokeColor).trim();
  }

  // Remove # if present and ensure it's hex format
  const hex = color.replace('#', '');
  const encodedColor = `%23${hex}`;

  return `"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='${encodedColor}' stroke-width='1' stroke-dasharray='${dashLength} ${gapLength}' stroke-linecap='round' rx='${borderRadius}' ry='${borderRadius}'/%3e%3c/svg%3e"`;
};
